import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import supriyadoc from './../../../../assets/images/Doctorsimages/supriyadr.png'
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const SupriyaDoc = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Dr. Supriya | Best Consultant Doctor in Guntur, Andhra Pradesh | Hcura Multispeciality Clinic";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Supriya (BDS), an expert Consultant Doctor at Hcura Multispeciality Clinic, Guntur, Andhra Pradesh. With 6 years of experience in dental care and aesthetic treatments, she provides honest and consistent care. Book today."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "consultant doctor in Guntur Andhra Pradesh, best doctor in Guntur, dental and aesthetic doctor Guntur, BDS doctor in Guntur, dental clinic in Guntur Andhra Pradesh, aesthetic treatment doctor Guntur, dental implant doctor in Guntur, skin and dental doctor Guntur, experienced doctor in Guntur"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalHref = "https://www.h-cura.com/doctors/dr-supriya-Dental-aesthetic-consultant";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalHref);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalHref);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');

    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvas.width;
        const imgWidth = canvas.width * scaleFactor;
        const imgHeight = canvas.height * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.Supriya_Profile_Guntur_AndhraPradesh.pdf');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Supriya</span>
                  <span className="veenadoc-title-credentials">(BDS)</span>
                  <span className="veenadoc-title-location">Guntur, Andhra Pradesh</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A highly skilled Consultant Doctor at Hcura Multispeciality Clinic in Guntur, Andhra Pradesh. 
                    With <strong>6 years of dedicated clinical experience</strong> across dental and aesthetic care, 
                    she provides expert, honest, and consistent treatment to every patient.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={supriyadoc} alt="Dr. Supriya, BDS, Consultant Doctor at Hcura Multispeciality Clinic in Guntur, Andhra Pradesh" className="veenadoc-doctor-image" title='Dr. Supriya – Consultant Doctor at Hcura Multispeciality Clinic Guntur, Andhra Pradesh' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>About Dr. Supriya</h2>
                  <p>
                    Dr. Supriya (BDS) is a experienced professional who completed her Bachelor of Dental Surgery from the prestigious 
                    SIBAR Institute of Dental Sciences in <strong>Andhra Pradesh</strong>. Her education provided a rigorous foundation 
                    in dental medicine and oral health management, which she has refined over <strong>6 years of practice</strong>.
                  </p>
                  <p>
                    She is recognized in Guntur, Andhra Pradesh, for her unique ability to combine dental expertise with 
                    modern aesthetic care, ensuring patients receive comprehensive wellness solutions in one location.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>6 Years of Clinical Excellence</h2>
                  <p>
                    Throughout her <strong>6-year professional journey</strong>, Dr. Supriya has worked across various elite clinical 
                    environments. Her background includes specialized experience at <strong>Advanced GroHair and Gloskin Clinic</strong> for 
                    aesthetics, <strong>Vcare</strong> for patient management, and <strong>Apple Dental Care</strong> and Implant Center for advanced restorative dentistry.
                  </p>
                  <p>
                    She also brings valuable experience from Clips N Kids Clinic, where she mastered the gentle approach 
                    required for pediatric dental care. This diverse background makes her one of the most versatile 
                    consultant doctors in Guntur, Andhra Pradesh.
                  </p>
                </div>
                  <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Supriya has gained recognition as a trichology doctor in Guntur specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">6 Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Dental & Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Guntur, Andhra Pradesh</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Expertise in Dental & Aesthetic Solutions</h2>
                  <p>
                    At Hcura Multispeciality Clinic, Guntur, Andhra Pradesh, Dr. Supriya specializes in dental implants, 
                    gum health management, and restorations. She is known for her ability to explain complex procedures 
                    in simple terms, helping patients feel confident and relaxed during their treatment.
                  </p>
                  <p>
                    Her aesthetic consultations focus on natural results and longevity. Whether it is a routine cleaning 
                    or an advanced skin treatment, her <strong>6 years of experience</strong> ensures that every assessment 
                    is honest and patient-centric.
                  </p>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Trusted Care in Guntur, Andhra Pradesh</h2>
                  <p>
                    Choosing Dr. Supriya means choosing a professional committed to sincerity and skill. At Hcura Guntur, 
                    she is part of a multispeciality team bringing dental, skin, hair, and homeopathy care together 
                    under one roof for the people of <strong>Andhra Pradesh</strong>.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To deliver experienced care with honesty and consistency, ensuring every patient in Guntur, Andhra Pradesh feels valued and healthy.
                  </p>
                </div>
              </div>

              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{ fontSize: '1.2rem' }}>
                      "Experienced care with honesty and driven by consistency"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Supriya's Philosophy of Care</p>
                  </div>
                  <p>
                    With <strong>6 years of proven experience</strong>, she believes that truthful guidance and 
                    consistent follow-up are the keys to lasting patient health.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Guntur, Andhra Pradesh</h4>
                      <p>Hcura Multispeciality Clinic</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Visit Guntur's trusted dental and aesthetic expert today.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow />

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Supriya's Profile (PDF)
        </button>
      </div>
    </>
  )
}

export default SupriyaDoc
